import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sgzp-app4.constants';

@Component({
  selector: 'app-sgzp-app4-change-password-sent',
  templateUrl: './sgzp-app4-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sgzp-app4-change-password-sent.component.css',
  ],
})
export class SgzpApp4ChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
